<template>
  <div class="standard-gap">
    <table v-if="standardGapList.length" border="1"
      style="width: 98%; border-collapse: collapse; margin: 10px auto;">
      <thead>
        <tr style="background-color: #0066cc; color: #fff;">
          <th :rowspan="2">班级</th>
          <th v-for="(course, index) in standardGapList[standardGapList.length - 1].courseStandardDeviationList" :key="index" :colspan="3">{{
            course.courseName }}</th>
        </tr>
        <tr style="background-color: #0066cc; color: #fff;">
          <template v-for="(course, index) in standardGapList[standardGapList.length - 1].courseStandardDeviationList">
            <th :key="index + 'avg'">标准差</th>
            <th :key="index + 'rank'">排名</th>
            <th :key="index + 'diff'">级差值</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(classItem, index) in standardGapList" :key="index">
          <td>{{ classItem.className }}</td>
          <template v-for="(course, cIndex) in standardGapList[standardGapList.length - 1].courseStandardDeviationList">
            <td :key="cIndex + 'avg'">{{ getCourseInfo(classItem, course.courseName, 'score') }}</td>
            <td :key="cIndex + 'rank'">{{ getCourseInfo(classItem, course.courseName, 'rank') }}</td>
            <td :key="cIndex + 'diff'">{{ getCourseInfo(classItem, course.courseName, 'gradeDifference') }}</td>
          </template>
        </tr>
      </tbody>
    </table>
    <div v-else><el-empty description="暂无数据"></el-empty></div>
  </div>
</template>

<script>
export default {
  props: ['standardGapList'],
  data() {
    return {

    }
  },
  methods: {
    getCourseInfo(classItem, courseName, infoType) {
      const courseInfo = classItem.courseStandardDeviationList.find(course => course.courseName === courseName);
      if (courseInfo  && courseInfo[infoType] != -1) {
        return courseInfo[infoType];
      } else {
        return '-'; // 如果找不到对应的课程信息，则返回'-'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './standardGap.scss';
</style>